import { Injectable } from '@angular/core';
import { CFHttpClient } from '../shared/cf-http-client';
import { Subject } from 'rxjs';
import { ModalOptions, BsModalService } from 'ngx-bootstrap/modal';
import { UtilService } from '@mem-shared/util.service';
import { UserSession } from '../shared/user-session';
import { DocViewerService } from '@mem-shared/doc-viewer.service';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ConfirmInfoReenterModalComponent } from './modals/confirm-info-reenter-modal/confirm-info-reenter-modal.component';


const formUrlEncodedHttpOptions = {
  headers: new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8'),
  params: new HttpParams().set('timeStamp', new Date().toISOString())
};

@Injectable()
export class RegistrationService {

  postValidateMemberRegistrationUrl = environment.servicePublicURLs.postValidateMemberRegistrationURL; //'/mas/pub/validateMemberRegistration.json';
  postRegisterMemberUrl = environment.servicePublicURLs.postRegisterMemberURL; //'/mas/pub/registerMember.json';
  validateIdentifierUrl = environment.servicePublicURLs.validateIdentifierURL; //'/mas/pub/decryptMemberRegistrationKey.json';
  updateMemberCommunicationInfoUrl = environment.servicePublicURLs.updateMemberCommunicationInfoURL; //'/mas/pub/updateMemberEmailOrPhoneInfo.json';
  sendEmailSecurityTokenUrl = environment.servicePublicURLs.sendEmailSecurityTokenURL; //'/mas/pub/sendEmailSecurityToken.json'
  verifyEmailSecurityTokenUrl = environment.servicePublicURLs.verifyEmailSecurityTokenURL; // '/mas/pub/verifyEmailSecurityToken.json'
  isUserIdAvailableForRegistrationUrl = environment.servicePublicURLs.isUserIdAvailableForRegistrationURL; // '/mas/pub/isUserIdAvailableForRegistration.json'
  sendMobilePhoneSecurityTokenUrl = environment.servicePublicURLs.sendMobilePhoneSecurityTokenURL //'/mas/pub/sendMobilePhoneSecurityToken.json',
  verifyMobilePhoneSecurityTokenUrl = environment.servicePublicURLs.verifyMobilePhoneSecurityTokenURL //'/mas/pub/verifyMobilePhoneSecurityToken.json'

  // ValidateMemberMockUrl = '../../../app_mock/registration/validateMemberRegistration.1.JSON';

  registrationService: any;
  userDetails: any;
  validateMemberAccount: string;
  validateMemberData = {
    seperatedSpouse: true
  };
  constructor(private http: CFHttpClient,
    private userSession: UserSession,
    private docViewer: DocViewerService,
    private httpClient: HttpClient,
    private utilSvc: UtilService,
    private modalService: BsModalService) {

    this.registrationService = {
      membersFound: false,
      validPassword: false,
      validateRegPage: false,
      hideButtons: false,
      errorPage: false,
      isErrorCode: false
    }

  }

  //get bearer authorization token to invoke Nexus services
  getSelfServiceToken() {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic ' + this.getBasicAuth()
    });
    const body = {
      params: new HttpParams().set('grant_type', 'client_credentials')
    };
    let options = {
      headers: headers
    };
    return this.httpClient.post(this.http.getAbsoluteURL('/v1/oauth/accesstoken'), body.params, options);
  }
  getBasicAuth() {
    const env = this.utilSvc.getEnvName();
    let token;
    if (env === 'dev' || env === 'sita') {
      token = "N1hDWXVYUUlLSFZ1VGZQM1hpOG9CQXNoQXl3R0c0UDlBbVNtTVZEamdpZWxjU3laOjlJYWxnQ3NoYWJWRGlKQjVweVpNdnR0VVBYS0Q5b1BFS2VFeVppY1J6VnhPM1RZZW1KbENydUlwS2dVeDViMVQ=";
    }
    else if (env === 'tt' || env === 'uat') {
      token = "Z3lsTk9ScGpYQ1JKcTNKM0hTbmJyVjM3cUhJSWRTY3h1SnNrUGFQRnpsQTduZGpQOnEydGl2d0pqcTdzbXV6U2pHOTJzUG1Edk1XZDVac0R4akQ2UGt2TUdSMThuc0dHaVFudVlDMjVzcW4xQ2o1ZmE=";
    }
    else {
      token = "Q0RjZ0R2MDJnTEtrNzVjdUxNSVBndVljRzNuVDhjUktDQWZ3SldDV3RXZXhDSERhOjNSN3FTSXBVTGo1eE5UaHRKQVdwclJZQW5IWW96SWZNUGVBN1RDZEJoNllaSkVaR0pvODMxMVhzaU9ucVF3ZHg=";
    }
    return token;
  }

  //To validate the user for registration
  postValidateMemberRegistration(params, token) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
      'X-CF-QUERY-PARAMS': params
    });
    let options = {
      headers: headers
    };
    return this.httpClient.post(this.http.getAbsoluteURL('/v1/cf-usrselfsrv/users/memberSelfServices/memberRegistrationValidations/'), null, options);
  }

  //send and varify token for email and phone
  sendAndVerifyToken(params, body, token) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
      'X-CF-QUERY-PARAMS': params
    });
    let options = {
      headers: headers
    };
    return this.httpClient.post(this.http.getAbsoluteURL('/v1/cf-usrselfsrv/users/memberSelfServices/securityTokens/'), body, options);
  }

  // Check if userid is available for registration
  validateUsername(params, token) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
      'X-CF-QUERY-PARAMS': params
    });
    let options = {
      headers: headers
    };
    return this.httpClient.post(this.http.getAbsoluteURL('/v1/cf-usrselfsrv/users/memberSelfServices/usernames/'), null, options);
  }

  //Register member & shopper 
  registerMember(params, reqBody, token) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
      'X-CF-QUERY-PARAMS': params
    });
    let options = {
      headers: headers
    };
    return this.httpClient.post(this.http.getAbsoluteURL('/v1/cf-usrselfsrv/users/memberSelfServices/memberRegistrations/'), reqBody, options);
  }


  // This method displays modal when user tries to Navigate Away from the Make Payment Page
  showLeaveModal() {
    window.scrollTo(0, 0);
    const modalOptions: ModalOptions = {
      class: 'modal-md'
    };
    this.modalService.show(ConfirmInfoReenterModalComponent, modalOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/new-registration/registration.service.ts